import Email from '@mui/icons-material/Email'
import { Box, Button, Grid, InputAdornment } from '@mui/material'
import React, { useState } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import { useDispatch } from 'react-redux'
import {
  getErrorCodeFromResult,
  isResultError,
} from '../../app/utils/ErrorHandling'
import ErrorMessage from '../../components/Common/ErrorMessage/ErrorMessage'
import Input from '../../components/FormFields/Input/Input'
import Card from '../../materialUI/components/Card/Card'
import CardBody from '../../materialUI/components/Card/CardBody'
import CardFooter from '../../materialUI/components/Card/CardFooter'
import { forgotPassword } from '../../reducers/authReducer'
import styles from './forgotPasswordPageStyle'

export default function ForgotPasswordPage(props: any) {
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [emailState, setemailState] = React.useState('error')
  const [errorMessage, setErrorMessage] = React.useState('')
  const [confirmation, setConfirmation] = React.useState<any>()

  const verifyEmail = (value: string) => {
    var emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (emailRex.test(value)) {
      return true
    }
    return false
  }

  const handleConfirmation = () => {
    setConfirmation(null)
    props.history.push('/auth/login')
  }

  const showConfirmation = () => {
    setConfirmation(
      <SweetAlert
        success
        style={{ display: 'block' }}
        title="Email Sent"
        onConfirm={() => handleConfirmation()}
        onCancel={() => handleConfirmation()}
        confirmBtnCssClass={styles.button + ' ' + styles.success}
      >
        Instructions sent to {email}
      </SweetAlert>,
    )
  }

  const handleSubmit = (evt: React.BaseSyntheticEvent) => {
    evt.preventDefault()

    dispatch(forgotPassword(email)).then((result: any) => {
      if (isResultError(result)) {
        const code = getErrorCodeFromResult(result)
        if (code == 'NFD001') {
          setErrorMessage('Email address is not recognised')
        } else {
          setErrorMessage(
            'A problem has occured please contact your system administrator',
          )
        }
      } else {
        setErrorMessage('')
        showConfirmation()
      }
    })
  }

  return (
    <Box component={'div'} sx={styles.container}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <form noValidate onSubmit={handleSubmit}>
            <Card product>
              <CardBody>
                <Box component={'div'} sx={styles.textCenter}>
                  <Box component={'h4'} sx={styles.cardTitle}>
                    Forgot your password?
                  </Box>
                  <p>
                    Enter your email below and follow the instructions sent to
                    this address to reset your password
                  </p>
                </Box>
                <Input
                  error={emailState === 'error'}
                  label="Email..."
                  inputProps={{
                    onChange: (e: React.BaseSyntheticEvent) => {
                      if (verifyEmail(e.target.value)) {
                        setemailState('success')
                        setEmail(e.target.value)
                      } else {
                        setemailState('error')
                      }
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <Email sx={styles.inputAdornmentIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
                <ErrorMessage setFromResult={false} message={errorMessage} />
              </CardBody>
              {/*
                            //@ts-ignore */}
              <CardFooter style={{ justifyContent: 'center' }}>
                {/*
                                //@ts-ignore */}
                <Button
                  sx={styles.forgotPasswordBtn}
                  type="submit"
                  color="info"
                  size="lg"
                  disabled={emailState === 'error'}
                  round={1}
                >
                  Reset Password
                </Button>
              </CardFooter>
            </Card>
          </form>
          {confirmation}
        </Grid>
      </Grid>
    </Box>
  )
}
